// extracted by mini-css-extract-plugin
export default {"container":"NavigationController_container__BPy5i","screen":"NavigationController_screen__BO0RO"};